import { inject, Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Bereitet CMS-HTML (WordPress) fuer [innerHTML] auf.
 *
 * Der Inhalt laeuft durch Angulars HTML-Sanitizer und wird NICHT per
 * bypassSecurityTrustHtml als vertrauenswuerdig markiert: das CMS ist von
 * Redakteuren editierbar, ein dort eingeschleustes <script>, onerror= oder
 * javascript:-Link wuerde sonst im Browser jedes Kunden laufen.
 *
 * Der Sanitizer behaelt alles, was der CMS-Inhalt tatsaechlich verwendet
 * (p, br, strong, b, i, u, ul/li, h2/h3, div, span, section, a mit
 * href/target/rel, class, lang, role, aria-*) und entfernt Skripte,
 * Event-Handler, unsichere URLs sowie id- und data-*-Attribute.
 */
@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {

  private readonly sanitizer = inject(DomSanitizer);

  transform(html: string | null | undefined): string {
    if (!html) {
      return '';
    }
    return this.sanitizer.sanitize(SecurityContext.HTML, html) ?? '';
  }
}
